export class RoleFilterEntity {
  id?: number
  searchWord?: string
  date?: Date[]
} 